import { render, staticRenderFns } from "./PreDeliveryRedirection.vue?vue&type=template&id=07b2c250&scoped=true"
import script from "./PreDeliveryRedirection.vue?vue&type=script&lang=js"
export * from "./PreDeliveryRedirection.vue?vue&type=script&lang=js"
import style0 from "./PreDeliveryRedirection.vue?vue&type=style&index=0&id=07b2c250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b2c250",
  null
  
)

export default component.exports